/**
 * Pulse Radio (WP4-RADIO, BUILD-PLAN M25): stations, zones, players and
 * overhead announcements for every office, as a Marketplace add-on. The
 * shell shows the locked panel when no office in scope holds `radio`.
 */
import { defineManifest } from '@velora/contracts';
import { RADIO_ENTITY, RADIO_FEATURE, RADIO_PERMISSIONS } from '@velora/contracts/radio';
import { defineWebModule } from '../../app/module.js';

const P = RADIO_PERMISSIONS;

export default defineWebModule({
  manifest: defineManifest({
    id: 'radio',
    title: 'Pulse Radio',
    version: '0.1.0',
    owner: 'WP4-RADIO',
    entitlementKey: RADIO_FEATURE,
    permissions: [...new Set(Object.values(P))],
    routes: [
      {
        id: 'radio',
        path: '/radio',
        title: 'Pulse Radio',
        permission: P.view,
        officeScope: 'location-or-all',
      },
    ],
    nav: [
      {
        label: 'Radio',
        group: 'operations',
        routeId: 'radio',
        icon: 'radio',
        order: 30,
        permission: P.view,
      },
    ],
    commands: [
      {
        id: 'radio.open',
        title: 'Go to Pulse Radio',
        keywords: ['music', 'radio', 'stations', 'zones', 'announcement', 'page', 'overhead'],
        routeId: 'radio',
        permission: P.view,
      },
    ],
    sseEntityKeys: Object.values(RADIO_ENTITY),
  }),
  pages: {
    radio: () => import('./RadioPage.js'),
  },
});
